import React from "react";
import _ from "lodash";
import SubviewError from "./SubviewError";
import styles from "./AppErrorView.module.css";

/**
 * This view is used to display an error that cannot be recovered from and would require the user to refresh the app
 */
class AppErrorView extends React.Component {
  _reload = () => {
    location.reload(true);
  };

  render() {
    let error = this.props.error;
    let userMessage = _.get(
      error,
      "userMessage",
      "Unfortunately we couldn't do something we needed to do."
    );

    let userMessageOnly = _.get(error, "userMessageOnly", false);
    let hideBtn = _.get(error, "hideBtn", false);

    const message = (
      <div style={{ textAlign: "center" }}>
        <div>{userMessage}</div>
        {userMessageOnly ? null : (
          <div>Please try reloading or contact support if the problem continues</div>
        )}
      </div>
    );

    return (
      <div className={styles["error-page"]}>
        <SubviewError
          error={error}
          onClose={this._reload}
          closeBtnLabel="Reload"
          showCloseBtn={!hideBtn}
          userMessage={message}
        />
      </div>
    );
  }
}

export default AppErrorView;
